import { render, staticRenderFns } from "./AppointmentTermFile.vue?vue&type=template&id=4e8f1d1a&scoped=true&"
import script from "./AppointmentTermFile.vue?vue&type=script&lang=js&"
export * from "./AppointmentTermFile.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentTermFile.vue?vue&type=style&index=0&id=4e8f1d1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8f1d1a",
  null
  
)

export default component.exports